<template>
    <v-radio-group v-model="period" :column="isMobile" >
        <div style="display: flex; align-items: start;">
            <div
                class="mr-12"
                v-for="(item, index) in periods"
                :key="index"
            >
                <v-radio
                    :value="item.interval"
                    color="secondary lighten-1"
                >
                    <template v-slot:label>
                        <strong class="white--text">{{item.label}}</strong>
                    </template>
                </v-radio>
                <span class="ml-8" style="font-family: Roboto;font-style: normal;font-size: 12px;line-height: 16px;">{{ item.dateTitle }}</span>
            </div>
            <div style="display: flex: flex-direction: column;">
                <v-radio
                    class="mr-6"
                    value="otherPeriod"
                    label="Outro período"
                    color="secondary lighten-1"
                >
                    <template v-slot:label>
                        <strong class="white--text">Outro período</strong>
                        <v-tooltip
                            top
                            color="primary darken-1"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="ml-2 pa-0"
                                    color="secondary lighten-1"
                                >
                                    help_outline
                                </v-icon>
                            </template>
                            <span>{{getTooltipText}}</span>
                        </v-tooltip>
                    </template>
                </v-radio>
                <date-field
                    ref="otherPeriodField"
                    :type="type"
                    :disabled="period !== 'otherPeriod'"
                    @cancelDateSelected="cancelDateSelected"
                    @applyDateSelected="applyDateSelected($event)"
                ></date-field>
            </div>
        </div>
    </v-radio-group>
</template>

<script>
/* import moment from "moment"; */
import DateField from './DateField.vue';
export default {
    name: "OtherPeriodsFields",
    props:{
        type: {
            type: String,
            default: "daily",
            required: true,
        },
        periods: {
            type: Array,
            required: true,
        }
    },
    components: { DateField },
    data: () => ({
        period: undefined,
        beforeDate: undefined,
        currentDate: undefined
    }),
    watch:{
        /* type(value){
            if(value){
                this.period = this.periods[0].interval;
            }
        }, */
        period(value){
            if(value !== 'otherPeriod'){
                /* const stringFormat = this.type === 'daily' ? 'YYYY-MM-DD' : this.type === 'monthly' ? 'YYYY-MM' : 'YYYY-MM-DDTHH:mm';
                const unit = this.type === 'daily' ? 'days' : this.type === 'monthly' ? 'months' : 'hours';
                const startDate = this.type === 'hourly' ? moment().subtract(value - 1, unit).startOf('hour') : moment().subtract(value - 1, unit);
                const startDateFormat = startDate.locale('pt-br').format(stringFormat);
                const endDate = this.type === 'hourly' ? moment().startOf('hour') : moment();
                const endDateFormat = endDate.locale('pt-br').format(stringFormat); */
                const { dateStart, dateFinal } = this.periods.find((periodItem) => periodItem.interval === value);
                const date =  [ dateStart, dateFinal ];
                this.applyDateSelected(date);
            }

            setTimeout(()=>{
                this.$refs.otherPeriodField.backOldDateValue(this.currentDate);
            }, 50);
        }
    },
    computed:{
        isMobile(){
            return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm';
        },
        getTooltipText(){
            if(this.type === "daily") return "Você pode buscar dados de até 90 dias passados.";
            if(this.type === "monthly") return "Você pode buscar dados de até 12 meses passados.";
            return "VocÃª pode buscar dados de até 7 dias passados.";
        }
    },
    methods:{
        cancelDateSelected(){
            this.$refs.otherPeriodField.backOldDateValue(this.currentDate);
        },
        applyDateSelected(date){
            this.beforeDate = this.currentDate;
            this.currentDate = date;
            this.$emit('applyPeriod', {period: this.currentDate, type: this.type});
        },
    }
}
</script>

<style scoped>
    label{
        order: -1;
        color: #ffffff;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 8px;
    }

    .v-input:focus-within + label{
        color: var(--v-secondary-lighten1);
    }

    .form-input-group{
        display: flex;
        flex-direction: column;
    }
</style>
